import { AnimatePresence, motion } from "framer-motion";

interface IndicadorComLoadingProps {
    label: string;
    loading?: boolean;
    value?: number | string;
}

function IndicadorComLoading({ label, loading, value }: IndicadorComLoadingProps) {
    return (
        <div className="numero-emb" style={{ maxWidth: 500, width: "100%", margin: "auto", padding: 12, alignItems: "center", display: "flex", justifyContent: "center" }}>
            <h3>{label}</h3>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: 40,
            }}>
                <AnimatePresence mode="wait">
                    {loading ? (
                        <motion.span
                            className="ai-help-spinner"
                            aria-hidden
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            style={{ width: 16, marginTop: 0 }}
                            transition={{ duration: 0.18 }}
                        />
                    ) : (
                        <motion.h3
                            key={value?.toString() ?? "0"}
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 10 }}
                            transition={{ duration: 0.2 }}
                        >
                            {value ?? 0}
                        </motion.h3>
                    )}
                </AnimatePresence>
            </div>
        </div>
    );
};

export default IndicadorComLoading;
